import React, { useCallback, useEffect, useRef, useState } from "react";
import ButtonTriangleSpinner from "../../../components/common/ButtonTriangleSpinner/ButtonTriangleSpinner.jsx";
import "./marketTrades.scss";
import CardHeading from "../../../components/common/CardHeading/CardHeading.jsx";
import TradeBuySell from "./TradeBuySell/TradeBuySell.jsx";
import { TradeBookHook } from "../../../hooks/marketDataHook";
const MarketTrades = ({
  sectionRef
}) => {
  const rootRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const {
    tradeBook,
    marketTradesFetching,
    marketTradesLoadMoreFetching,
    marketTradesHasMore,
    loadMoreMarketTrades
  } = TradeBookHook();
  const setMarketTradesRootRef = useCallback(node => {
    rootRef.current = node;
    if (typeof sectionRef === "function") {
      sectionRef(node);
    } else if (sectionRef) {
      sectionRef.current = node;
    }
  }, [sectionRef]);
  useEffect(() => {
    const syncFullscreen = () => {
      const el = rootRef.current;
      const active = document.fullscreenElement === el || document.webkitFullscreenElement === el;
      setIsFullscreen(Boolean(active));
    };
    document.addEventListener("fullscreenchange", syncFullscreen);
    document.addEventListener("webkitfullscreenchange", syncFullscreen);
    syncFullscreen();
    return () => {
      document.removeEventListener("fullscreenchange", syncFullscreen);
      document.removeEventListener("webkitfullscreenchange", syncFullscreen);
    };
  }, []);
  const showFooter = marketTradesLoadMoreFetching || Boolean(marketTradesHasMore) && !marketTradesFetching;
  const list = Array.isArray(tradeBook) ? tradeBook : [];
  return <div className={`marketTrades${isFullscreen ? " is-fullscreen" : ""}`} ref={setMarketTradesRootRef}>
            <div className="marketTrades__panel">
                <CardHeading title="Market Trades" />
                <div className="marketTrades__body">
                    <TradeBuySell head={true} clrclass="red_text" tradeBook={list} />
                    {showFooter ? <div className="tableLoaderBtn marketTrades__loadMore">
                            <button className="btn-style black-btn tableLoaderBtn__action w-100" disabled={marketTradesFetching || !marketTradesHasMore} onClick={loadMoreMarketTrades} type="button" aria-busy={Boolean(marketTradesLoadMoreFetching)}>
                                <span className="tableLoaderBtn__label">
                                    {marketTradesLoadMoreFetching ? "Loading" : "Load More"}
                                </span>
                                {marketTradesLoadMoreFetching ? <span className="tableLoaderBtn__spinner-inline" aria-hidden="true">
                                        <ButtonTriangleSpinner size={18} />
                                    </span> : null}
                            </button>
                        </div> : null}
                </div>
            </div>
        </div>;
};
export default MarketTrades;